import { api } from '@/lib/axios'
import type {
  CalcBomCategory,
  CalcLostReason,
  CalcPhase,
  CalcQualification,
  CalcRegieRate,
  CalcTimeStandard,
  CalcTimeStandardProposal,
  CalcWorkStepTemplate,
  CalculationSettings,
} from '../types/calculation.types'

/**
 * AP-37 10. — Einstellungen der Kalkulation und die gemeinsamen Listen mit dem
 * Projektmanagement (`/calculation-settings/...`, Gate `CALCULATION.CORE`).
 */
const basis = '/calculation-settings'

export const fetchCalculationSettings = () =>
  api.get<{ data: CalculationSettings }>(basis).then((r) => r.data.data)

export const fetchLostReasons = () => api.get<{ data: CalcLostReason[] }>(`${basis}/lost-reasons`).then((r) => r.data.data)
export const createLostReason = (dto: { name: string; key?: string }) =>
  api.post<{ data: CalcLostReason }>(`${basis}/lost-reasons`, dto).then((r) => r.data.data)
export const deleteLostReason = (id: string) => api.delete(`${basis}/lost-reasons/${id}`)

// Detailblatt N 6.5 — Richtwerte (`.CORE`)
export const fetchTimeStandards = (alle = false) =>
  api.get<{ data: CalcTimeStandard[] }>(`${basis}/time-standards`, { params: alle ? { all: 1 } : {} }).then((r) => r.data.data)
export const createTimeStandard = (dto: Partial<CalcTimeStandard> & { activityName: string; referenceName: string; referenceUnitCode: string; hoursPerReference: number }) =>
  api.post<{ data: CalcTimeStandard }>(`${basis}/time-standards`, dto).then((r) => r.data.data)
export const deleteTimeStandard = (id: string) => api.delete(`${basis}/time-standards/${id}`)
export const timeStandardsFromControlling = () =>
  api.post<{ data: CalcTimeStandardProposal[] }>(`${basis}/time-standards/from-controlling`).then((r) => r.data.data)

/** Nachtrag 4 (N4-3): Kategorien — gepflegt in den Einstellungen des Projektmanagements. */
export const fetchCalcBomCategories = () => api.get<{ data: CalcBomCategory[] }>(`${basis}/bom-categories`).then((r) => r.data.data)
export const fetchCalcPhases = () => api.get<{ data: CalcPhase[] }>(`${basis}/phases`).then((r) => r.data.data)
export const createCalcPhase = (dto: { key: string; name: string }) =>
  api.post<{ data: CalcPhase }>(`${basis}/phases`, dto).then((r) => r.data.data)
export const deleteCalcPhase = (id: string) => api.delete(`${basis}/phases/${id}`)

export const fetchCalcQualifications = () =>
  api.get<{ data: CalcQualification[] }>(`${basis}/qualifications`).then((r) => r.data.data)
export const createCalcQualification = (dto: { code: string; name: string }) =>
  api.post<{ data: CalcQualification }>(`${basis}/qualifications`, dto).then((r) => r.data.data)
export const deleteCalcQualification = (id: string) => api.delete(`${basis}/qualifications/${id}`)

export const fetchCalcRegieRates = () => api.get<{ data: CalcRegieRate[] }>(`${basis}/regie-rates`).then((r) => r.data.data)
export const createCalcRegieRate = (dto: { qualificationId: string; rate: number; validFrom?: string }) =>
  api.post<{ data: CalcRegieRate }>(`${basis}/regie-rates`, dto).then((r) => r.data.data)
export const deleteCalcRegieRate = (id: string) => api.delete(`${basis}/regie-rates/${id}`)

export const fetchCalcWorkStepTemplates = () =>
  api.get<{ data: CalcWorkStepTemplate[] }>(`${basis}/workstep-templates`).then((r) => r.data.data)
export const createCalcWorkStepTemplate = (dto: { phaseId: string; activityName: string }) =>
  api.post<{ data: CalcWorkStepTemplate }>(`${basis}/workstep-templates`, dto).then((r) => r.data.data)
export const deleteCalcWorkStepTemplate = (id: string) => api.delete(`${basis}/workstep-templates/${id}`)

/** Artikelgruppen für den Verschnitt — nur mit gebuchter Artikelverwaltung. */
export const fetchArticleGroupsForWaste = () =>
  api.get<{ data: { id: string; name: string; isActive?: boolean }[] }>('/articles/groups').then((r) => r.data.data)
